import { Action, createReducer, on } from '@ngrx/store';
import * as fromRefundRequestActions from 'app/store/refund-request/refund-request.actions';
import { initialState, RefundRequestState } from './refund-request.state';

const _refundRequestReducer = createReducer(
  initialState,
  on(
    fromRefundRequestActions.updateRefundRequestIsLoadingFromRefundData,
    (state, { isLoading }) => ({ ...state, isLoading: isLoading })
  )
);

export function refundRequestReducer(
  state: RefundRequestState | null,
  action: Action
) {
  return _refundRequestReducer(state, action);
}